import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListHealthUnitResponse } from '../../responses/user/list-health-unit.response';

@Injectable({
  providedIn: 'root'
})
export class HealthUnitService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }
  
  public listHealthUnit(): Observable<ListHealthUnitResponse> {
    
    let uri = `HealthUnit/getAll`
    
    return this.httpClient.get<ListHealthUnitResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}

